import React from 'react';

const SolutionsPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <section className="relative py-20 bg-gradient-to-br from-blue-900 via-cyan-900 to-blue-900 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '50px 50px' }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Our Solutions</h1>
          <p className="text-xl md:text-2xl text-cyan-100 max-w-4xl mx-auto">CareTap AI (Mobile Patient App) & CareTap Nexus Provider Portal</p>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">See CareTap AI in Action</h2>
            <p className="text-xl text-gray-600">Watch how our platform revolutionizes healthcare data management</p>
          </div>
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
            <video controls className="w-full aspect-video" poster="https://customer-assets.emergentagent.com/job_healthcare-system-5/artifacts/hstbld5s_%7BBackground%7DHealthcare%20at%20your%20Fingertips_caretapai.png">
              <source src="https://customer-assets.emergentagent.com/job_healthcare-system-5/artifacts/4lcnusut_caretap-ai-demo.mp4.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 border border-blue-200">
              <div className="text-5xl mb-4">📊</div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Efficient Insights for Providers</h3>
              <p className="text-gray-700 leading-relaxed">Delivering a comprehensive solution for healthcare providers, insurers, and legal firms to streamline workflows, enhance data management, and gain actionable insights.</p>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 border border-purple-200">
              <div className="text-5xl mb-4">🤖</div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">AI Powered</h3>
              <p className="text-gray-700 leading-relaxed">Revolutionizing healthcare with predictive analytics, plain-language medical data summaries, and analyzing patient health records to provide actionable insights.</p>
            </div>
            <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-2xl p-8 border border-green-200">
              <div className="text-5xl mb-4">📱</div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Records On the Go</h3>
              <p className="text-gray-700 leading-relaxed">Providing patients with seamless access to their health data, telemedicine, and appointment management through intuitive mobile apps.</p>
            </div>
            <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 border border-orange-200">
              <div className="text-5xl mb-4">🌐</div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Cross Market Data Share</h3>
              <p className="text-gray-700 leading-relaxed">Fully FHIR-compliant, enabling smooth integration with all major EHR systems across the U.S.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-blue-900 via-purple-900 to-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-block px-6 py-2 bg-cyan-500 rounded-full mb-6">
              <span className="text-white font-bold">OUT OF THE BOX SOLUTION</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold mb-6">InterOp Suite</h2>
            <p className="text-2xl md:text-3xl text-cyan-100 mb-4">One-Click FHIR & Automated ONC Compliance</p>
            <p className="text-xl text-cyan-200 max-w-3xl mx-auto">Fastest implementation of HL7 FHIR for healthcare data</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
              <h3 className="text-2xl font-bold mb-6 flex items-center gap-3">
                <svg className="w-8 h-8 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Key Features
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <span className="text-cyan-400 text-xl">•</span>
                  <span>Ready-to-use API integrates seamlessly with your EHR</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-cyan-400 text-xl">•</span>
                  <span>Auto conversion to FHIR R4 with built-in security and audit logs</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-cyan-400 text-xl">•</span>
                  <span>Certified-ready endpoints for ONC certification requirements</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-cyan-400 text-xl">•</span>
                  <span className="text-yellow-300 font-semibold">Stay compliant: December 31, 2025 deadline</span>
                </li>
              </ul>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
              <h3 className="text-2xl font-bold mb-6">⚠️ Compliance Alert</h3>
              <div className="bg-red-500/20 border-2 border-red-400 rounded-xl p-6 mb-6">
                <p className="text-lg font-semibold mb-2">ONC Certification Deadline</p>
                <p className="text-3xl font-bold text-yellow-300 mb-2">December 31, 2025</p>
                <p>ONC certification requires FHIR for data exchange</p>
              </div>
              <div className="bg-green-500/20 border-2 border-green-400 rounded-xl p-6">
                <p className="text-lg font-semibold mb-2">✅ FHIR Compliance</p>
                <p>We help EHRs comply with ONC HTI-1 regulation</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-12 text-gray-900">
            <h3 className="text-4xl font-bold text-center mb-12">Build vs Buy: Why Choose InterOpSuite</h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="bg-red-50 border-2 border-red-300 rounded-2xl p-8">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">❌</div>
                  <h4 className="text-2xl font-bold text-red-900">Building In-House</h4>
                </div>
                <ul className="space-y-4 text-gray-700">
                  <li className="flex items-start gap-3"><span className="text-red-500 font-bold">•</span><span>Requires FHIR expertise and dedicated development team</span></li>
                  <li className="flex items-start gap-3"><span className="text-red-500 font-bold">•</span><span>Long development cycle (12-18 months or more)</span></li>
                  <li className="flex items-start gap-3"><span className="text-red-500 font-bold">•</span><span className="font-semibold text-red-900">High costs (often $300K+ for initial build)</span></li>
                  <li className="flex items-start gap-3"><span className="text-red-500 font-bold">•</span><span>Must manage hosting, security, and scalability yourself</span></li>
                </ul>
              </div>

              <div className="bg-green-50 border-2 border-green-300 rounded-2xl p-8">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">✅</div>
                  <h4 className="text-2xl font-bold text-green-900">Buying InterOpSuite</h4>
                </div>
                <ul className="space-y-4 text-gray-700">
                  <li className="flex items-start gap-3"><span className="text-green-500 font-bold">✓</span><span>Turnkey FHIR infrastructure ready-to-use</span></li>
                  <li className="flex items-start gap-3"><span className="text-green-500 font-bold">✓</span><span>Rapid implementation in days or weeks</span></li>
                  <li className="flex items-start gap-3"><span className="text-green-500 font-bold">✓</span><span className="font-semibold text-green-900">50% lower cost with predictable pricing</span></li>
                  <li className="flex items-start gap-3"><span className="text-green-500 font-bold">✓</span><span>Built-in security, HIPAA compliance, no experts needed</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-12">Ideal Customers & Personas</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Target Customers</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <span className="text-blue-600 text-xl">🏥</span>
                  <div><p className="font-semibold text-gray-900">Small to mid-sized EHR vendors</p><p className="text-gray-600 text-sm">Organizations needing quick HTI-1 compliance</p></div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-purple-600 text-xl">🧠</span>
                  <div><p className="font-semibold text-gray-900">Specialty and post-acute care EHRs</p><p className="text-gray-600 text-sm">Behavioral health and vertical-specific vendors</p></div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-green-600 text-xl">🚀</span>
                  <div><p className="font-semibold text-gray-900">Digital health startups</p><p className="text-gray-600 text-sm">AI companies needing FHIR data access</p></div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-orange-600 text-xl">🏛️</span>
                  <div><p className="font-semibold text-gray-900">Payers and insurers</p><p className="text-gray-600 text-sm">Bi-directional exchange via FHIR</p></div>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Key Personas</h3>
              <div className="space-y-6">
                <div className="border-l-4 border-blue-500 pl-4">
                  <p className="font-semibold text-gray-900 mb-2">CTO or VP Engineering</p>
                  <p className="text-gray-600 text-sm">Needs turnkey FHIR solution for quick compliance</p>
                </div>
                <div className="border-l-4 border-purple-500 pl-4">
                  <p className="font-semibold text-gray-900 mb-2">Compliance / IT leaders</p>
                  <p className="text-gray-600 text-sm">Focused on audit readiness and security</p>
                </div>
                <div className="border-l-4 border-green-500 pl-4">
                  <p className="font-semibold text-gray-900 mb-2">Product teams</p>
                  <p className="text-gray-600 text-sm">Need simple APIs and ready-made endpoints</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-blue-600 to-cyan-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Ready to Transform Your Healthcare Operations?</h2>
          <p className="text-xl text-cyan-100 mb-8">Get started with CareTap AI and InterOpSuite today</p>
          <a href="mailto:info@caretapnexus.com" className="inline-block px-8 py-4 bg-white text-blue-600 rounded-full font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300">Contact Us Today</a>
        </div>
      </section>
    </div>
  );
};

export default SolutionsPage;
